// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2v9TD","addWidgetButton":"Header_addWidgetButton__1Ps3b","dashboardTabs":"Header_dashboardTabs__2OyN2","active":"Header_active__2SaYz"};